import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHeart$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHeart extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4dd2eccbd9ae1d7d120c9e0ad665757f835bcd00', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'efe7eb88f0c39ff209c5af1987f927da22188f72', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'cc82bd2081b6e58c1da0f97c2a119711bda12fdb', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11 16.06 5.66-5.87a3.04 3.04 0 0 0 .85-2.1 2.537 2.537 0 0 0-2.48-2.59 2.4 2.4 0 0 0-1.75.76l-1.92 1.96a.485.485 0 0 1-.72 0L8.72 6.26a2.4 2.4 0 0 0-1.75-.76 2.537 2.537 0 0 0-2.48 2.59 3.08 3.08 0 0 0 .85 2.1zm-.34 1.8-6.4-6.63A4.57 4.57 0 0 1 3 8.08 4.01 4.01 0 0 1 6.97 4 3.93 3.93 0 0 1 9.8 5.22L11 6.44l1.2-1.22A3.93 3.93 0 0 1 15.03 4 4.01 4.01 0 0 1 19 8.08a4.5 4.5 0 0 1-1.26 3.15l-6.4 6.63A.44.44 0 0 1 11 18a.44.44 0 0 1-.34-.14", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-heart", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-heart"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-heart":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHeart$1);
            }
            break;
    } });
}

const CosmosIconHeart = CosmosIconHeart$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHeart, defineCustomElement };
